import React from 'react'
import { motion } from "framer-motion"
import { useEase } from "../motion"

export const TitleTerriers = (props) => {

	const parentControl = {
		closed: {
			opacity: 1,
			transition: {
				duration: 1,
			},
		},
		open: {
			opacity: 1,
			transition: {
				duration: 1.5,
				delayChildren: 1.35,
				staggerChildren: 0.1,
				when: "afterChildren",
			},
		},
	}

	const letterVar = {
		closed: {
			x: -15.25,
			y: -300,
			opacity: 0,
		},
		open: {
			opacity: 1,
			x: -15.25,
			y: -9.22,
			transition: {
				type: "spring",
				bounce: 0.6,
				duration: 0.8,
			},
		},
	}

   return (
		<div className="chapter-title">
			<motion.svg
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 690.69 62.64"
				variants={parentControl}
				initial="closed"
				animate={props.coverLoaded ? "open" : "closed"}
				exit="closed"
			>
				<defs>
					<clipPath id="clipPath" transform="translate(-15.25 -9.22)">
						<rect width="79" height="79" fill="none" />
					</clipPath>
					<clipPath
						id="clipPath-2"
						transform="translate(-15.25 -9.22)"
					>
						<rect
							x="110"
							y="6"
							width="356"
							height="73"
							fill="none"
						/>
					</clipPath>
					<clipPath
						id="clipPath-3"
						transform="translate(-15.25 -9.22)"
					>
						<rect
							x="480"
							y="6"
							width="234"
							height="73"
							fill="none"
						/>
					</clipPath>
				</defs>
				<g id="terriers" className="isolation">
					<g id="group_a">
						<g>
							<g id="a" className="isolation">
								<motion.path
									variants={letterVar}
									d="M28.21,71.87h-13L35.43,9.22H50.05L70.23,71.87H56.75l-4.09-14.1H32.39Zm3-15.84H53.88L58,70.13H68L48.92,11H36.56l-19,59.17H27ZM62.84,66.82,46.74,14.27h-8L22.38,66.82H24l4.35-14.09H56.92l4.27,14.09ZM39.78,16H45.7L56.4,51H28.91ZM51.44,47.68,43.26,19.49H42L33.69,47.68ZM42.65,23l6.62,23H35.87Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
							</g>
						</g>
					</g>
					<g id="group_terrier">
						<g>
							<g id="terrier">
								<motion.path
									variants={letterVar}
									d="M145,20.88v51H132.44v-51H116.08V9.22h45.24V20.88Zm-10.79-1.74v51h9v-51h16.35V11H117.82v8.18Zm3.65-3.22v50.9h1.74V15.92h16.36V14.18H121.47v1.74Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M211.35,9.22V21.06H182.9V33.93h23V45.77h-23V60h28.45V71.87h-41V9.22Zm-1.74,60.91V61.78H181.16V44h23.05V35.67H181.16V19.32h28.45V11h-37.5V70.13ZM206,66.82V65.08H177.5V40.72h23.06V39H177.5V16H206V14.27H175.76V66.82Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M245,48.64H234.92V71.87H222.39V9.22h31.93c7.31,0,12.36,5,12.36,12.36v14.7c0,5.92-3.31,10.36-8.53,11.84l10.44,23.75H255.11ZM233.18,70.13V46.9h12.88l10.09,23.23H266L255.8,46.9c5.57-.61,9.14-4.7,9.14-10.62V21.58c0-6.35-4.27-10.62-10.62-10.62H224.13V70.13Zm28.1-47.33c0-5.4-3.13-8.53-8.52-8.53h-25V66.82h1.74V43.68h19.14l10.09,23.14h1.83L250.5,43.68h2.26c5.39,0,8.52-3.13,8.52-8.53ZM252.76,16c4.35,0,6.78,2.44,6.78,6.79V35.15c0,4.35-2.43,6.79-6.78,6.79H229.53V16Zm-1.57,3.31a4.34,4.34,0,0,1,4.7,4.7V34a4.3,4.3,0,0,1-4.7,4.7h-18V19.32Zm3,4.7a2.66,2.66,0,0,0-3-3H234.92V37h16.27a2.66,2.66,0,0,0,3-3Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M301.56,48.64H291.47V71.87H278.94V9.22h31.93c7.31,0,12.36,5,12.36,12.36v14.7c0,5.92-3.31,10.36-8.53,11.84l10.44,23.75H311.66ZM289.73,70.13V46.9h12.88L312.7,70.13h9.83L312.35,46.9c5.57-.61,9.14-4.7,9.14-10.62V21.58c0-6.35-4.27-10.62-10.62-10.62H280.68V70.13Zm28.1-47.33c0-5.4-3.13-8.53-8.52-8.53h-25V66.82h1.74V43.68h19.14l10.09,23.14h1.83L307,43.68h2.27c5.39,0,8.52-3.13,8.52-8.53ZM309.31,16c4.35,0,6.78,2.44,6.78,6.79V35.15c0,4.35-2.43,6.79-6.78,6.79H286.08V16Zm-1.57,3.31a4.34,4.34,0,0,1,4.7,4.7V34a4.3,4.3,0,0,1-4.7,4.7h-18V19.32Zm3,4.7a2.66,2.66,0,0,0-3-3H291.47V37h16.27a2.66,2.66,0,0,0,3-3Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M335.49,9.22H348V71.87H335.49Zm10.79,60.91V11h-9V70.13Zm-3.65-3.31V14.27h-1.74V66.82Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M402.74,9.22V21.06H374.29V33.93h23.06V45.77H374.29V60h28.45V71.87h-41V9.22ZM401,70.13V61.78H372.55V44h23.06V35.67H372.55V19.32H401V11H363.5V70.13Zm-3.65-3.31V65.08H368.9V40.72H392V39H368.9V16h28.45V14.27H367.16V66.82Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M436.41,48.64H426.32V71.87H413.79V9.22h31.93c7.31,0,12.36,5,12.36,12.36v14.7c0,5.92-3.31,10.36-8.53,11.84L460,71.87H446.5ZM424.58,70.13V46.9h12.88l10.09,23.23h9.83L447.2,46.9c5.57-.61,9.14-4.7,9.14-10.62V21.58c0-6.35-4.27-10.62-10.62-10.62H415.53V70.13Zm28.1-47.33c0-5.4-3.13-8.53-8.53-8.53h-25V66.82h1.74V43.68h19.14l10.1,23.14H452L441.89,43.68h2.26c5.4,0,8.53-3.13,8.53-8.53ZM444.15,16c4.35,0,6.79,2.44,6.79,6.79V35.15c0,4.35-2.44,6.79-6.79,6.79H420.92V16Zm-1.56,3.31a4.34,4.34,0,0,1,4.7,4.7V34a4.3,4.3,0,0,1-4.7,4.7h-18V19.32Zm3,4.7a2.66,2.66,0,0,0-3-3H426.32V37h16.27a2.66,2.66,0,0,0,3-3Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
							</g>
						</g>
					</g>
					<g id="group_title">
						<g>
							<g id="title">
								<motion.path
									variants={letterVar}
									d="M515.41,20.88v51H502.88v-51H486.52V9.22h45.24V20.88Zm-10.79-1.74v51h9v-51H530V11H488.26v8.18Zm3.65-3.22v50.9H510V15.92h16.36V14.18H491.92v1.74Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M540.81,9.22h12.53V71.87H540.81ZM551.6,70.13V11h-9.05V70.13Zm-3.66-3.31V14.27H546.2V66.82Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M591.27,20.88v51H578.74v-51H562.38V9.22h45.25V20.88Zm-10.79-1.74v51h9v-51h16.36V11H564.12v8.18Zm3.66-3.22v50.9h1.74V15.92h16.35V14.18H567.78v1.74Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M629.2,9.22V60h26.28V71.87H616.67V9.22Zm24.54,60.91V61.78H627.46V11h-9.05V70.13Zm-3.66-3.31V65.08H623.81V14.27h-1.75V66.82Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
								<motion.path
									variants={letterVar}
									d="M705.94,9.22V21.06H677.48V33.93h23.06V45.77H677.48V60h28.46V71.87H665V9.22Zm-1.75,60.91V61.78H675.74V44H698.8V35.67H675.74V19.32h28.45V11H666.7V70.13Zm-3.65-3.31V65.08H672.09V40.72h23.06V39H672.09V16h28.45V14.27H670.35V66.82Z"
									// transform="translate(-15.25 -9.22)"
									fill="currentColor"
								/>
							</g>
						</g>
					</g>
				</g>
			</motion.svg>
		</div>
   )
}